import React from 'react';
import { Box, Typography } from '@mui/material';
import TileShell from '../../../components/tiles/TileShell';
import InterviewsBadge from '../../../components/tiles/InterviewsBadge';
import ScoreBadge from '../../../components/tiles/ScoreBadge';

export default function JobBadgeTile({ title, count, pct, avgProductSat, href }) {
  const metricsRow = (
    <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap' }}>
      <InterviewsBadge percent={pct} count={count} />
      {Number.isFinite(avgProductSat) && (
        <ScoreBadge label="Product satisfaction" value={avgProductSat} metricKey="satisfaction" />
      )}
    </Box>
  );

  return (
    <TileShell
      typePill="job"
      title={title}
      metricsRow={metricsRow}
      linkTo={href}
      href={href}
    />
  );
}
